'<persist_error>':
    en: 'Exception occurred while saving planning results. Session could not be completed. Restart planning.'
    da: 'Exception occurred while saving planning results. Session could not be completed. Restart planning.'
    es:
        'Ha ocurrido una excepción mientras se guardaban los resultados. La sesión podría no estar completada.
        Re-iniciar la planificación.'
    fr:
        'Un évènement est survenu lors de l’enregistrement des résultats de la planification. La planification n’a pas
        été enregistrée. Veuillez redémarrer la planification.'
    pt:
        'Ocorreu uma exceção ao guardar os resultados de planeamento. A sessão não pôde ser concluída. Por favor
        reinicie o planeamento.'
    ru:
        'В процессе сохранения результатов планирования произошла ошибка. Сессия не может быть завершена. Необходимо
        перезапустить планирование.'
    us: 'Exception occurred while saving planning results. Session could not be completed. Restart planning.'
'<terminated>':
    en: 'Scheduling process was manually terminated'
    ru: 'Процесс планирования был завершен вручную'
    pt: 'O processo planeamento foi terminado de forma manual'
'<try_again_later>':
    en: 'The server is busy. Please try again later'
    es: 'El servidor está ocupado. Intentelo mas tarde'
    fr: "Le serveur est occupé. S'il vous plaît réessayer plus tard"
    pt: 'O servidor está ocupado. Por favor tente mais tarde'
    ru: 'Сервер занят. Пожалуйста, повторите попытку позже'
'<planning_already_running>':
    en: 'A planning process already running for your distribution centre. Please wait.'
    es: 'Un proceso de planificación está ya en curso en tu centro de distribución. Por favor, espere'
    ru: 'В Вашем распределительном центре уже идет процесс планирования. Пожалуйста подождите.'
    pt: 'Um processo de planeamento já está a decorrer no seu centro de distribuição. Por favor espere.'
'<run_can_not_be_unplanned>':
    en: 'Run {0} can not be unplanned.'
    es: 'La ejecución{0}  no puede ser no-planificada'
    fr: 'L’annulation de la tournée {0} est impossible.'
    pt: 'Impossível anular a planificação da rota {0}.'
    ru: 'Поездка {0} не может быть отпланирована.'
'<all_notfixed_runs_were_unallocated>':
    en: 'All not fixed runs were unallocated.'
    es: 'Todo lo que no era ejecuciones fijas fue desasignado.'
    fr: 'Annulation de l’allocation de toutes les tournées non affermies.'
    pt: 'Todas as rotas não fixas tiveram a atribuição anulada.'
    ru: 'Все незафиксированные поездки были отпланированы.'
'<empty_params>':
    en: 'Not all parameters were specified to run a command'
    pt: 'Nem todos os parâmetros estão especeficados para correr um comando'
'<invalid_hash>':
    en: 'Some Runs were changed. Please reload screen'
    es: 'Algunas rutas han cambiado. Por favor, refrescar la pantalla'
    fr: "Certains tournées ont été modifiés. Veuillez recharger l'écran"
    pt: 'Algumas rotas foram alteradas. For favor refresque a janela'
    ru: 'Некоторые рейсы были изменены. Необходимо обновить страницу'
'<invalid_location>':
    en: 'Order has an error and can not be allocated:'
    ru: 'Заказ имеет ошибки и не может быть запланирован:'
    pt: 'A ordem tem um erro e não pode ser atribuída'
'<redo_does_not_possible>':
    en: 'Redo operation is not possible'
    ru: 'Операция возвращения не может быть выполнена'
    pt: 'Não é possível andar para a frente na operação'
'<undo_does_not_possible>':
    en: 'Undo operation is not possible'
    ru: 'Операция отмены не может быть выполнена'
    pt: 'Não é possível andar para trás na operação'
'<some_pnd_orders_invalid_for_planning>':
    en: 'Some pnd orders invalid for planning'
    ru: 'Некоторые заказы pnd непригодны для планирования'
    es: 'algunos pedidos no son válidos para la planificación'
    pt: 'algumas ordens são inválidas para planeamento'
